import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/sys/temp',
  owner: '/home',
  authority: 'templateList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};